module.exports = __webpack_public_path__ + "img/growing_heart.bf7e34da.gif";